import { Renderer2, Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';

@Injectable({
    providedIn: 'root',
})
export class ScriptService {
    constructor(@Inject(DOCUMENT) private document: Document) {}

    public loadJsScript(renderer: Renderer2, src: string): HTMLScriptElement {
        const script = renderer.createElement('script');
        script.type = 'text/javascript';
        script.src = src;
        renderer.appendChild(this.document.body, script);
        return script;
    }

    public loadJs(renderer: Renderer2, data: any): any {
        let script = renderer.createElement('script');
        script.text = data;

        renderer.appendChild(this.document.body, script);
        return script;
    }

    public removeScript(renderer: Renderer2, data: any): void {
        if (this.document.body.contains(data)) {
            renderer.removeChild(this.document.body, data);
        }
    }

    public loadNoScriptImg(renderer: Renderer2, src: string): HTMLElement {
        const noScript = renderer.createElement('noscript');
        const img = renderer.createElement('img');
        img.src = src;
        img.height = 1;
        img.width = 1;
        renderer.appendChild(this.document.body, noScript);
        renderer.appendChild(noScript, img);
        return noScript;
    }
}
